module.exports = __webpack_public_path__ + "img/forward.b4e9ae13.svg";